import { toBoolean } from 'shared/utils/common'

export const SYNERISE_API_URL = 'https://api.synerise.com'
export const SYNERISE_TRACKER_KEY =
  process.env.NEXT_PUBLIC_SYNERISE_TRACKER_KEY || ''
export const SYNERISE_CAMPAIGN_RECOMMENDATION_PATH =
  '/recommendations/v2/recommend/campaigns/'

export const IS_SYNERISE_RECOMMENDATION_ENABLED =
  process.env.NEXT_PUBLIC_IS_SYNERISE_RECOMMENDATION_ENABLED === 'true'

export const SYNERISE_CART_RECOMMENDATION_CAMPAIGN_ID =
  process.env.NEXT_PUBLIC_SYNERISE_CART_RECOMMENDATION_CAMPAIGN_ID || ''
export const SYNERISE_PERSONALIZED_RECOMMENDATION_CAMPAIGN_ID =
  process.env.NEXT_PUBLIC_SYNERISE_PERSONALIZED_RECOMMENDATION_CAMPAIGN_ID || ''
export const SYNERISE_SIMILAR_ITEMS_RECOMMENDATION_CAMPAIGN_ID =
  process.env.NEXT_PUBLIC_SYNERISE_SIMILAR_ITEMS_RECOMMENDATION_CAMPAIGN_ID ||
  ''

export const IS_SYNERISE_CART_RECOMMENDATION_ENABLED =
  IS_SYNERISE_RECOMMENDATION_ENABLED &&
  toBoolean(SYNERISE_CART_RECOMMENDATION_CAMPAIGN_ID)
export const IS_SYNERISE_PERSONALIZED_RECOMMENDATION_ENABLED =
  IS_SYNERISE_RECOMMENDATION_ENABLED &&
  toBoolean(SYNERISE_PERSONALIZED_RECOMMENDATION_CAMPAIGN_ID)
export const IS_SYNERISE_SIMILAR_ITEMS_RECOMMENDATION_ENABLED =
  IS_SYNERISE_RECOMMENDATION_ENABLED &&
  toBoolean(SYNERISE_SIMILAR_ITEMS_RECOMMENDATION_CAMPAIGN_ID)

export const SYNERISE_API_RESPONSE_TIMEOUT = 1500 // ms
